<template>
  <div class="number-grow-warp">
    <span ref="numberGrow" class="number-grow">0</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      default: 1000
    }
  },
  methods: {
    numberGrow (ele) {
      let _this = this

      let step = (_this.value * 10) / (_this.time * 1000)
      let current = 0
      let start = 0
      let t = setInterval(function () {
        start += step
        if (start > _this.value) {
          clearInterval(t)
          start = _this.value
          t = null
        }
        if (current === start) {
          return
        }
        current = start
        // ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
        ele.innerHTML = parseInt(current.toString())
      }, 10)
    }
  },
  mounted () {
    this.numberGrow(this.$refs.numberGrow)
  }
}
</script>

<style lang="scss" scoped>
.number-grow-warp{
  display: inline;
  transform: translateZ(0);
  font-family: PingFang SC;
}
</style>
